"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataMigrationService = void 0;
class DataMigrationService {
    constructor(httpRequest) {
        this.httpRequest = httpRequest;
    }
    /**
     * Change publisher to pending deployment
     * @returns any Successful response
     * @throws ApiError
     */
    publisherToPendingDeployment() {
        return this.httpRequest.request({
            method: 'GET',
            url: '/data-migration/publishers',
        });
    }
    /**
     * Copy finance agent from CRM
     * @returns any Successful response
     * @throws ApiError
     */
    copyFinanceAgent() {
        return this.httpRequest.request({
            method: 'GET',
            url: '/data-migration/finance-agent',
        });
    }
}
exports.DataMigrationService = DataMigrationService;
